const FOCUSABLE =
  'a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])';

export function initMobileMenu() {
  const nav = document.querySelector(".nav");
  if (!nav) return;

  const toggle = nav.querySelector(".nav__toggle");
  const closeBtn = nav.querySelector(".nav__close");
  const drawer = nav.querySelector(".nav__drawer");
  const backdrop = nav.querySelector(".nav__backdrop");
  if (!toggle || !drawer) return;

  const isOpen = () => nav.classList.contains("is-open");

  const open = () => {
    nav.classList.add("is-open");
    toggle.setAttribute("aria-expanded", "true");
    document.body.classList.add("has-open-menu");
    (drawer.querySelector(FOCUSABLE) || closeBtn)?.focus();
  };

  const close = ({ returnFocus = true } = {}) => {
    nav.classList.remove("is-open");
    toggle.setAttribute("aria-expanded", "false");
    document.body.classList.remove("has-open-menu");
    if (returnFocus) toggle.focus();
  };

  toggle.addEventListener("click", () => (isOpen() ? close() : open()));
  closeBtn?.addEventListener("click", () => close());
  backdrop?.addEventListener("click", () => close());

  drawer.querySelectorAll("a").forEach((link) => {
    link.addEventListener("click", () => close({ returnFocus: false }));
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && isOpen()) close();
  });

  drawer.addEventListener("keydown", (e) => {
    if (e.key !== "Tab" || !isOpen()) return;

    const items = [...drawer.querySelectorAll(FOCUSABLE)].filter(
      (el) => el.offsetParent !== null,
    );
    if (!items.length) return;

    const first = items[0];
    const last = items[items.length - 1];

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });

  window
    .matchMedia("(min-width: 1101px)")
    .addEventListener("change", (e) => {
      if (e.matches && isOpen()) close({ returnFocus: false });
    });
}
